import Alpine from "alpinejs"

Alpine.data("modal", () => ({
    open: false,
    init() {
        this.$refs.dialog.addEventListener("close", () => {
            this.open = false
        })
    },
    toggle() {
        if (this.open) {
            this.$refs.dialog.close()
        } else {
            this.$refs.dialog.showModal()
            this.$refs.dialog.blur()
        }
        this.open = !this.open
    },
}))
